<template>
  <div>
    <div
      class="card"
      v-for="(item, index) in listingArray"
      :key="item.id"
    >
      <a :href="item.Url" class="details-arrow">
        <img src="../../../../Assets/Images/left-white-arrow.png" alt="arrow" />
      </a>
      <a class="card-body card-title">
        {{ item.Title }}
      </a>

      <div
        :id="item.Id"
        class="collapse"
        :class="index == 0 || (index == 0 && mobileView) ? 'show' : ''"
        aria-labelledby="headingOne"
        data-parent="#accordionExample"
      >
        <div class="card-body">
          <div
            class="seprator"
            style="background-image: url('../../../../Assets/Images/seprator.svg')"
          ></div>

          <div class="row data">
            <div class="col-sm-12 col-lg-6">
              <div class="data__details">
                <div class="data__details__title">
                  {{ surveyCardObj.SurveyStatus }}
                </div>
                <div class="data__details__description">
                  {{ item.Status || "-" }}
                </div>
              </div>
              <div class="data__details">
                <div class="data__details__title">
                  {{ surveyCardObj.SurveyStartDate }}
                </div>
                <div class="data__details__description">
                  <div>{{ item.StartDate || "-" }}</div>
                </div>
              </div>
              <div class="data__details">
                <div class="data__details__title">
                  {{ surveyCardObj.SurveyFunction }}
                </div>
                <div class="data__details__description">
                    <span v-if="!item.Functions">-</span>
                    <span v-for="(func, index) in item.Functions" :key="index">
                        {{ func }}
                        <span v-if="index != item.Functions.length-1 && item.Functions.length != 1">-</span>
                    </span>
                </div>
              </div>
              <div class="data__details">
                <div class="data__details__title">
                  {{ surveyCardObj.SurveySector }}
                </div>
                <div class="data__details__description">
                    <span v-if="!item.Sectors">-</span>
                    <span v-for="(sec, index) in item.Sectors" :key="index">
                        {{ sec }}
                        <span v-if="index != item.Sectors.length-1 && item.Sectors.length != 1">-</span>
                    </span>
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-lg-6">
              <div class="data__details">
                <div class="data__details__title">
                  {{ surveyCardObj.SurveyResponse }}
                </div>
                <div class="data__details__description">
                    {{ item.Responses || "-" }}
                </div>
              </div>

              <div class="data__details">
                <div class="data__details__title">
                  {{ surveyCardObj.SurveyEndDate }}
                </div>
                <div class="data__details__description">
                    {{ item.EndDate || "-" }}
                </div>
              </div>

              <div class="data__details">
                <div class="data__details__title">
                  {{ surveyCardObj.SurveyHealthProduct }}
                </div>
                <div class="data__details__description">
                    <span v-if="!item.HealthProducts">-</span>
                    <span v-for="(HealthProduct, index) in item.HealthProducts" :key="index">
                        {{ HealthProduct }}
                        <span v-if="index != item.HealthProducts.length-1 && item.HealthProducts.length != 1">
                            -
                        </span>
                    </span>
                </div>
              </div>
                <div class="data__details">
                <div class="data__details__title">
                  {{ surveyCardObj.SurveyDescription }}
                </div>
                <div class="data__details__description">
                    {{ item.Description || "-" }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-header" id="headingOne">
        <h2 class="mb-0">
          <button
            class="btn btn-link btn-block text-center filterCollapse"
            type="button"
            data-toggle="collapse"
            :data-target="'#' + item.Id"
            aria-expanded="true"
            :aria-controls="item.Id"
          >
            <!-- <i class="icon-expand"></i> -->
            <div class="icon-wrapper">
              <div class="custom-icon-expand">
                <div class="custom-icon-expand__rect"></div>
                <div class="custom-icon-expand__triangle"></div>
              </div>

              <div class="custom-icon-collapse">
                <div class="custom-icon-collapse__triangle"></div>
                <div class="custom-icon-collapse__rect"></div>
              </div>
            </div>
          </button>
        </h2>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  data() {
    return {};
  },
  props: {
    surveyCardObj: {
      type: Object,
    },
    serviceCardArr: {
      type: Array,
    },
    mobileView: {
      type: Boolean,
    },
  },
  methods: {},
  computed: {
    listingArray() {
      let lang = 'ar'
      if(location.pathname.includes('/en')) {
      lang = 'en'
      }
      let serviceArray = JSON.parse(JSON.stringify(this.serviceCardArr))
      serviceArray.map((x) => {
          if(lang === 'ar') {
            x.Responses = x.Responses.replace( /[0-9]/igm , (number)=> parseInt(number).toLocaleString('ar-EG') )
          }
          x.StartDate = moment(new Date(x.StartDate))
              .locale(lang)
              .format("DD - MMM - YYYY");
          x.EndDate = moment(new Date(x.EndDate))
              .locale(lang)
              .format("DD - MMM - YYYY");
      });
      return serviceArray;
    }
  }
};
</script>
